module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ThematicDetailView.js"));
	}, "ThematicDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ThematicDetailView!./src/pages/Learn/Thematic/Detail/ThematicDetailView.js
// module id = 2223
// module chunks = 367